// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__3Mn3E","label":"LabeledBox_label__MrHbR"};